import React from "react";
import { useLocation, withRouter } from "react-router-dom";
import { EventType } from "@azure/msal-browser";
import { withMsal } from "@azure/msal-react";
import { Auth, Hub } from "aws-amplify";
import { connect } from "react-redux";
import { compose } from "redux";
import cx from "classnames";
import axios from "axios";
import _ from "lodash";
import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  NavLink
} from "reactstrap";

import CTBG from "assets/images/CT/CT-bg.png";
import avatar from "assets/images/newAvatar.png";
import totBackground from "assets/images/tot/tot-banner.png";
import gameover_modal from "assets/images/gameOver_modal.svg";
import BoardRoom from "assets/images/charty-party/BoardRoom.jpg";
import twBackground from "assets/images/backgrounds/twBackground.jpg";
import overBackgroundOCH from "assets/images/OCH/OverBackgroundOCH.png";
import JoinTeam from "components/team/joinTeam";
import Alert from "components/shared/common/alert";
import HeyLimeLayout from "components/heylime-layout";
import OPT from "pages/offPlatformTracking";
import * as gameAction from "redux/game/action";
import * as loaderAction from "redux/loader/action";
import * as webUrlAction from "redux/webUrl/action";
import * as socketAction from "redux/sockets/action";
import * as gameParamAction from "redux/gameParams/actions";
import Socket from "socket/socket";
import Footer from "./footer";
import Header from "./header";
import Sidebar from "./sidebar";
import signUpOrSignInWithMicrosoftToken from "../msal";
import onSignIn from "../shared/utils/onSignIn";
import getTeamApiCall from "../shared/utils/getTeamApiCall";
import { end_Game, gameCodeHandler, PATH_ARRAY } from "../shared/utils";
import InGameJoinTeam from "../team/inGameJoinTeam";

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.getAllParams();
    this.getAllGames();
    this.state = {
      dropdownOpen: false,
      need_account_text: "",
      sign_in_text: "",
      sign_in_sign_up_text: "",
      how_to_play_text: "",
      join_a_game_text: "",
      cognitoUser: false,
      socket_connected: false,
      direct_game: false,
      joinTeamModal: false,
      rejected_team_users: []
    };
  }

  connectToServer = (res) => {
    Socket.connect(res, () => {
      console.log(
        "%c#####SOCKET-CONNECTED#####",
        "background: green; padding: 2px;"
      );
      const join_team_flow_active = new URLSearchParams(
        this.props.history.location.search
      ).get("_branch_match_id");

      this.props.setSocket(true);
      const isBilling = this.props.history.location.pathname === "/billing";

      _.isEmpty(this.props.gameReducer.currentUser)
        ? this.props.setIsLoading(false)
        : !isBilling &&
          join_team_flow_active === null &&
          this.props.setIsLoading(false);
    });
  };

  deletePlayer = (data) => {
    const { gameReducer } = this.props;
    const roomData = gameReducer.roomObj;
    let dataObj = {
      action: "remove-user",
      roomId: roomData.id,
      playerId: data.player_id,
      displayName: data.display_name
    };
    Socket.sendMessage(dataObj);
  };

  getAllParams = () => {
    this.props.setIsLoading(true);
    this.props.getAudioParams();

    this.props
      .getAllParams()
      .then((resp) => {
        this.connectToServer(resp);
      })
      .catch((err) => {
        this.props.setIsLoading(false);
        this.connectToServer(err);
      });
  };

  getAllGames = () => {
    this.props
      .getAllGames()
      .then(async (res) => {})
      .catch((err) => {
        this.props.setIsLoading(false);
        Alert(400, "Falied to Get Games");
      });
  };

  isDirectGameLink = () => {
    const pathname = this.props.history.location.pathname.toLowerCase();
    return PATH_ARRAY.includes(pathname);
  };

  componentWillUnmount() {
    this.removeListener();
    if (this.state.callbackId) {
      this.props.msalContext.instance.removeEventCallback(
        this.state.callbackId
      );
    }
  }

  async componentDidMount() {
    const callbackId = this.props.msalContext.instance.addEventCallback(
      (message) => {
        // This will be run every time an event is emitted after registering this callback
        if (message.eventType === EventType.LOGIN_SUCCESS) {
          const result = message.payload;
          this.props.setIsLoading(true);
          signUpOrSignInWithMicrosoftToken(result);
        }
      }
    );

    this.setState({ callbackId: callbackId });

    if (this.isDirectGameLink()) {
      this.setState({ ...this.state, socket_connected: true });
    }

    this.removeListener = Socket.addListener("end-game", (res) => {
      if (res) {
        this.setState({ rejected_team_users: [] });
      }
    });
    this.removeListener = Socket.addListener("add-to-team", (res) => {
      this.props.setIsLoading(false);
    });
    var cognitoUser = await Auth.userPool.getCurrentUser();
    const allparams = this.props?.gameReducer?.gamesData?.onboarding;
    if (cognitoUser !== null) {
      Auth.currentAuthenticatedUser({
        bypassCache: true
      })
        .then(async (userAuth) => {
          if (userAuth) {
            let payload = userAuth?.signInUserSession?.idToken?.payload;
            const join_team_flow_active = new URLSearchParams(
              this.props.history.location.search
            ).get("_branch_match_id");

            await onSignIn(payload, false, join_team_flow_active);
            this.setState({
              cognitoUser: true
            });
          }
        })
        .catch((err) => {
          this.props.setIsLoading(false);
          console.log("erroringame===>>>", err);
        });
    }

    if (allparams) {
      this.setState({
        need_account_text: allparams.need_account_text,
        sign_in_text: allparams["sign-in_text"],
        sign_in_sign_up_text: allparams.sign_in_sign_up_text,
        how_to_play_text: allparams.how_to_play_text,
        join_a_game_text: allparams.join_a_game_text,
        play_laterURL: allparams.play_laterURL,
        play_later_text: allparams.play_later_text
      });
    }

    let localauth = localStorage.getItem("auth");
    if (localauth !== "login") {
      this.props.setIsLoading(true);
      this.props.setCurrentUser({});
      this.setState({ dropdownOpen: false });
      await Auth.signOut()
        .then((user) => {
          localStorage.removeItem("auth");
          this.props.endGame(true);
          this.props.setCurrentUser({});
        })
        .catch((err) => {});
    }
    Hub.listen("auth", async ({ payload: { event, data } }) => {
      switch (event) {
        case "signIn":
          await this.setUserDetails(data);

          if (this.props.gameReducer.currentUser?.team?.AnnualPlanState != null)
            localStorage.setItem("annualNotification", "true");
          else localStorage.removeItem("annualNotification");

          localStorage.setItem("auth", "login");
          if (sessionStorage.getItem("trailSocialLogin") === "true") {
            const disablePhoneNum = sessionStorage.getItem("disablePhoneNum");
            this.props.history.push("/trial-login");
            if (disablePhoneNum === "true") {
              this.props.history.push("/trial-login");
            } else {
              this.props.history.push("/trial-login?path=a");
            }
            sessionStorage.removeItem("trailSocialLogin");
            sessionStorage.removeItem("disablePhoneNum");
          }
          break;
        case "signOut":
          this.props.setCurrentUser({});
          localStorage.removeItem("auth");
          break;
        default:
      }
    });

    const location = window.location.href;
    const search = location.includes("?") ? "?" + location.split("?")[1] : "";
    const teamcode = new URLSearchParams(search).get("teamcode");
    const teamCode = sessionStorage.getItem("teamCode")
      ? sessionStorage.getItem("teamCode")
      : teamcode;
    if (teamCode) {
      this.getTeamCode(teamCode);
    }
  }

  getTeamCode = async (teamCode) => {
    const search = useLocation().search;
    const cognitoUser = await Auth.userPool.getCurrentUser();
    const magicBranchUrl = new URLSearchParams(search).get("_branch_match_id");

    if (cognitoUser !== null && magicBranchUrl !== null) {
      this.setState({ joinTeamModal: true });
    } else {
      sessionStorage.setItem("teamCode", teamCode);
      this.props.history.push("/signup");
    }
  };

  setUserDetails = async (data) => {
    let payload = data.signInUserSession.idToken.payload;
    await onSignIn(payload);
    localStorage.removeItem("temp_utm_medium");
    localStorage.removeItem("temp_utm_source");
    localStorage.removeItem("temp_utm_campaign");
    localStorage.removeItem("temp_utm_content");

    const isDirectGameLink = localStorage.getItem("directGameLink");
    let localGameCode = sessionStorage.getItem("gameCode");
    let localHostCode = localStorage.getItem("hostjoinCode");

    if (localGameCode !== null && localHostCode === null && !isDirectGameLink) {
      this.props.setGameName(sessionStorage.getItem("gameCode"));
      this.props.history.push("/lobby");
    }
    if (localGameCode === null && localHostCode !== null) {
      localStorage.setItem("webUrl", true);
      localStorage.setItem("branchlinkforviewer", true);
      let data = {
        action: "get-room",
        joinCode: localHostCode
      };
      Socket.sendMessage(data);
    }
    if (localGameCode !== null && localHostCode !== null) {
      localStorage.setItem("webUrl", true);
      localStorage.setItem("branchlinkforviewer", true);
      let data = {
        action: "get-room",
        joinCode: localHostCode
      };
      Socket.sendMessage(data);
    }
    if (isDirectGameLink) {
      this.setState({ ...this.state, direct_game: true });
    } else {
      if (this.props?.gameReducer?.gameName) {
        const gameName = this.props.gameReducer.gameName;
        if (gameName === "GAHW") {
          localStorage.setItem("work_game", gameName);
          this.props.setGameName("GAH");
        } else if (gameName === "GAHF") {
          localStorage.setItem("work_game", gameName);
          this.props.setGameName("GAH");
        } else if (gameName === "CHPTW") {
          localStorage.setItem("work_game", gameName);
          this.props.setGameName("CHPT");
        } else {
          localStorage.removeItem("work_game");
        }
        this.props.history.push("/lobby");
      }
    }
    let user_Code = sessionStorage.getItem("teamCode");
    if (user_Code) {
      this.getTeamCode(user_Code);
    }
  };

  getGameCode = () => {
    let pathname = this.props.history.location.pathname.toLowerCase();
    return gameCodeHandler(pathname);
  };

  handleStartLink = () => {
    let roomData = this.props.gameReducer.roomObj;
    !_.isEmpty(roomData) && end_Game(roomData);
    const game_code = this.getGameCode();
    let cognitoUser = Auth.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      if (game_code === "GAHW") {
        localStorage.setItem("work_game", game_code);
        this.props.setGameName("GAH");
      } else if (game_code === "GAHF") {
        localStorage.setItem("work_game", game_code);
        this.props.setGameName("GAH");
      } else if (game_code === "CHPTW") {
        localStorage.setItem("work_game", game_code);
        this.props.setGameName("CHPT");
      } else {
        this.props.setGameName(game_code);
        localStorage.removeItem("work_game");
      }
      this.props.history.push("/lobby");
    } else {
      sessionStorage.setItem("gameCode", game_code);
      localStorage.setItem("directGameLink", true);
      this.props.setGameName(game_code);
      this.props.history.push("/signup");
    }
    this.setState({ ...this.state, socket_connected: false });
  };

  handleStartLoginLink = () => {
    let roomData = this.props.gameReducer.roomObj;
    !_.isEmpty(roomData) && end_Game(roomData);
    const game_code = sessionStorage.getItem("gameCode");
    let cognitoUser = Auth.userPool.getCurrentUser();
    if (cognitoUser !== null) {
      if (game_code === "GAHW") {
        localStorage.setItem("work_game", game_code);
        this.props.setGameName("GAH");
      } else if (game_code === "GAHF") {
        localStorage.setItem("work_game", game_code);
        this.props.setGameName("GAH");
      } else if (game_code === "CHPTW") {
        localStorage.setItem("work_game", game_code);
        this.props.setGameName("CHPT");
      } else {
        this.props.setGameName(game_code);
        localStorage.removeItem("work_game");
      }
      this.props.history.push("/lobby");
    } else {
      sessionStorage.setItem("gameCode", game_code);
      this.props.setGameName(game_code);
      this.props.history.push("/signup");
    }
    this.setState({ ...this.state, direct_game: false });
    localStorage.removeItem("directGameLink");
  };

  async componentDidUpdate() {
    if (
      this.state.socket_connected &&
      this.props.socketReducer?.socketConnection
    ) {
      this.handleStartLink();
    }
    if (this.state.direct_game && this.props.socketReducer?.socketConnection) {
      this.handleStartLoginLink();
    }
    try {
      const user = this.props?.gameReducer?.currentUser;
      if (user.email) {
        if (this.state.cognitoUser === false) {
          this.setState({ cognitoUser: true });
        } else {
          this.state.cognitoUser = false;
        }
      }

      let localGameCode = sessionStorage.getItem("gameCode");
      let localHostCode = localStorage.getItem("hostjoinCode");
      if (localGameCode === null && localHostCode !== null) {
        localStorage.setItem("webUrl", true);
        localStorage.setItem("branchlinkforviewer", true);
        let data = {
          action: "get-room",
          joinCode: localHostCode
        };
        Socket.sendMessage(data);
      }
    } catch (error) {}
  }

  async onLogOut() {
    sessionStorage.clear();
    this.props.setIsLoading(true);
    localStorage.removeItem("utm_medium");
    localStorage.removeItem("utm_source");
    localStorage.removeItem("utm_campaign");
    localStorage.removeItem("utm_content");
    localStorage.removeItem("webUrl");
    localStorage.removeItem("viewer");
    localStorage.removeItem("setwebUrl");
    this.props.setViewerWebUrl(false);
    localStorage.removeItem("temp_utm_source");
    localStorage.removeItem("temp_utm_content");
    localStorage.removeItem("temp_utm_medium");
    localStorage.removeItem("temp_utm_campaign");
    sessionStorage.removeItem("gameCode");
    localStorage.removeItem("work_game");
    localStorage.removeItem("mailId");
    sessionStorage.removeItem("teamCode");
    sessionStorage.removeItem("trailSocialLogin");
    this.props.setGameName("");
    this.props.endGame(true);
    this.props.emptyGameData({});
    this.props.setIsLoading(true);
    this.props.setCurrentUser({});
    this.setState({ dropdownOpen: false });
    localStorage.removeItem("auth");
    await Auth.signOut()
      .then((user) => {
        this.props.endGame(true);
        this.props.setCurrentUser({});
        this.props.setIsLoading(false);
        this.props.history.push("/signup");
      })
      .catch((err) => {});
  }

  toggleHandel = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen
    }));
  };

  handleSignInForm = () => {
    this.props.history.push("/signup");
  };

  handleJoinTeamModal = () => {
    this.setState({ joinTeamModal: !this.state.joinTeamModal });
  };

  show_join_team_modal = () => {
    const users = this?.props?.gameReducer?.roomObj?.users;

    const currentUser = this?.props?.gameReducer?.currentUser;
    const team = currentUser?.team;
    if (this?.props?.gameReducer?.roomObj.active_game) {
      if (!team) {
        return [];
      }
      const team_users = team?.users || [];
      let players_to_show = [];
      !_.isEmpty(users) &&
        (players_to_show =
          users &&
          users?.filter((user) => {
            if (
              user.user_id.includes("guest-") ||
              user.user_id.includes("bot") ||
              user.user_id === currentUser.userId
            ) {
              return false;
            } else {
              for (let team_member of team_users) {
                if (team_member.Username == user.user_id) {
                  return false;
                }
              }
              return true;
            }
          }));
      players_to_show = players_to_show?.filter((player) => {
        if (
          player.add_to_team_response == false ||
          player.add_to_team_response == true
        ) {
          return false;
        } else {
          return true;
        }
      });
      players_to_show = players_to_show?.filter((player) => {
        if (
          player.promo_expiration_date &&
          new Date(player.promo_expiration_date) > new Date()
        ) {
          return false;
        } else {
          return true;
        }
      });
      return players_to_show;
    } else {
      return [];
    }
  };

  handle_reject_join_team = (item) => {
    const temp = [...this.state.rejected_team_users, ...item];
    this.setState({ ...this.state, rejected_team_users: temp });
    let roomData = this.props.gameReducer.roomObj;
    const user_ids = item.map((i) => {
      return {
        playerId: i.player_id,
        response: false
      };
    });
    let dataObj = {
      action: "add-to-team",
      roomId: roomData.id,
      user_ids
    };
    this.props.setIsLoading(true);
    Socket.sendMessage(dataObj);
  };

  handle_accept_join_team = async (item) => {
    this.props.setIsLoading(true);
    let roomData = this.props.gameReducer.roomObj;
    let team_code = this?.props?.gameReducer?.currentUser?.team?.id;
    const user_ids = item.map((i) => {
      return {
        playerId: i.player_id,
        response: true
      };
    });
    let dataObj = {
      action: "add-to-team",
      roomId: roomData.id,
      user_ids
    };
    this.props.setIsLoading(true);
    Socket.sendMessage(dataObj);
    const promises = item.map((i) => this.join_team_api(team_code, i.user_id));
    const res = await Promise.all(promises);
    const res22 = await getTeamApiCall(team_code);
    this.props.setCurrentUser({
      ...this.props.gameReducer.currentUser,
      team: res22
    });
    this.setState({ rejected_team_users: [] });
    this.props.setIsLoading(false);
  };

  join_team_api = (code, user_id) => {
    let url = `${process.env.REACT_APP_CHECK_PROMOCODE}?userId=${user_id}&promocode=${code}`;
    return axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY
      }
    });
  };

  render() {
    const {
      children,
      history,
      gameReducer,
      paramsReducer,
      socketReducer,
      webUrlReducer
    } = this.props;
    const { pathname } = history.location;

    const roomData = gameReducer.roomObj;
    const params = paramsReducer.paramsObj;
    let gameObj = paramsReducer.gameObj;
    let gameTitle =
      roomData?.game_code === "DW20"
        ? gameObj?.screens?.lobby?.top_label
        : roomData && roomData.tabletop && roomData.tabletop.tabletop_name;
    const user = this.props?.gameReducer?.currentUser;
    const viewerWebUrl = webUrlReducer.viewerWebUrl;
    const active_game = socketReducer.active_game;

    let show_end_game_modal = false;
    if (active_game === false) {
      if (viewerWebUrl || localStorage.getItem("webUrl")) {
        show_end_game_modal = true;
      }
    }

    const showDropdown = () => {
      return (
        window.location.pathname.includes("/my-team") ||
        window.location.pathname.includes("/team-challenges") ||
        window.location.pathname.includes("/outside_team_building") ||
        window.location.pathname.includes("/team-reports") ||
        window.location.pathname === "/" ||
        window.location.pathname.includes("/activities") ||
        window.location.pathname.includes("/trial-login") ||
        window.location.pathname.includes("/signup") ||
        window.location.pathname.includes("/pricing_page") ||
        window.location.pathname.includes("/delete_account") ||
        window.location.pathname.includes("/password_reset") ||
        window.location.pathname.includes("/delete_account_success") ||
        window.location.pathname.includes("/account") ||
        window.location.pathname.includes("/invite_teammates") ||
        this.props.gameReducer.gameName === "WELL" ||
        window.location.pathname.includes("/billing")
      );
    };

    return (
      <>
        {viewerWebUrl && <div className="webUrldiv"></div>}
        {show_end_game_modal && (
          <Modal
            isOpen={true}
            centered
            className="game-over-modal"
            backdropClassName="gamemodal-backdrop"
          >
            <img src={gameover_modal} alt="" />
          </Modal>
        )}

        <div
          className={cx("main-layout", {
            "verboden-game":
              pathname.includes("verboden") || roomData?.game_code === "VB",
            "tot-game": pathname.includes("tot")
          })}
          style={
            pathname.includes("done-with-2020") ||
            roomData?.game_code === "DW20"
              ? {
                  backgroundColor: "#fff",
                  backgroundImage: `url(${
                    gameObj ? gameObj?.tabletop_bg_url : ""
                  })`
                }
              : pathname.includes("tot") || roomData?.game_code === "TOT"
              ? {
                  backgroundImage: `url(${totBackground})`
                }
              : pathname === "/" || pathname.includes("launch_controller")
              ? { backgroundColor: "#142943" }
              : pathname.includes("ochos-locos") &&
                roomData?.game_state?.status === "Over"
              ? {
                  backgroundColor: "#1E3C60",
                  backgroundImage: `url(${
                    gameObj ? gameObj?.screens?.lobby?.background : ""
                  })`
                }
              : pathname.includes("ochos-locos") &&
                roomData?.game_state?.status === "ResultRound"
              ? {
                  backgroundColor: "#1E3C60",
                  backgroundImage: `url(${overBackgroundOCH})`
                }
              : pathname.includes("ochos-locos")
              ? {
                  backgroundColor: "#1E3C60",
                  backgroundImage: `url(${
                    gameObj ? gameObj?.screens?.och?.background : ""
                  })`
                }
              : roomData.game_code === "GAH" && !roomData?.edition
              ? {
                  backgroundColor: "#ABF6FF",
                  backgroundImage: `url(${
                    gameObj && gameObj.tabletop_bg_url
                      ? gameObj.tabletop_bg_url
                      : ""
                  })`
                }
              : roomData.game_code === "TW"
              ? {
                  backgroundColor: "##FFFFFF",
                  backgroundImage: `url(${
                    gameObj && gameObj.tabletop_bg_url
                      ? gameObj.tabletop_bg_url
                      : ""
                  })`
                }
              : roomData?.game_code === "OCH"
              ? {
                  backgroundImage: `url(${gameObj?.screens?.lobby?.background})`
                }
              : roomData?.game_code === "CT"
              ? { backgroundImage: `url(${CTBG})` }
              : pathname.includes("charity-game") ||
                (roomData?.game_code === "CHPT" && !roomData?.edition)
              ? {
                  backgroundImage: `url(${BoardRoom})`,
                  backgroundColor: "#722F82"
                }
              : pathname.includes("slidekick") || roomData?.game_code === "SK"
              ? {
                  backgroundColor: "#f6f9ff"
                }
              : roomData?.edition === "GAHW"
              ? {
                  backgroundColor: "#ABF6FF",
                  backgroundImage: `url(${
                    gameObj && gameObj.tabletop_bg_url_work
                      ? gameObj.tabletop_bg_url_work
                      : ""
                  })`
                }
              : roomData?.edition === "GAHF"
              ? {
                  backgroundColor: "#ABF6FF",
                  backgroundImage: `url(${
                    gameObj && gameObj.tabletop_bg_url_family
                      ? gameObj.tabletop_bg_url_family
                      : ""
                  })`
                }
              : roomData?.edition === "CHPTW"
              ? {
                  backgroundImage: `url(${BoardRoom})`,
                  backgroundColor: "#722F82"
                }
              : { backgroundColor: "#1E3C60" }
          }
        >
          <div
            className={cx(
              "main-layout bingo-main-layout small-bites-main-layout",
              {
                "verboden-game":
                  pathname.includes("verboden") || roomData?.game_code === "VB",
                "tot-game": pathname.includes("tot"),
                "landing-library": pathname.includes("landing-library"),
                "account-bg": pathname === "account",
                totogame: roomData?.game_code === "TOTO",
                whiteBg:
                  pathname.includes("billing") ||
                  pathname.includes("wronghost") ||
                  pathname.includes("activities") ||
                  pathname.includes("team-challenges") ||
                  pathname.includes("launch_controller") ||
                  pathname.includes("outside_team_building")
              }
            )}
            style={
              pathname.includes("team-challenges")
                ? {
                    backgroundColor: "#fff"
                  }
                : pathname.includes("done-with-2020") ||
                  roomData?.game_code === "DW20"
                ? {
                    backgroundColor: "#fff",
                    backgroundImage: `url(${
                      gameObj ? gameObj?.tabletop_bg_url : ""
                    })`
                  }
                : pathname.includes("verboden") || roomData?.game_code === "VB"
                ? {
                    backgroundColor: "red !important"
                  }
                : pathname.includes("tot") ||
                  (roomData?.game_code === "TOT" &&
                    !pathname.includes("my-team"))
                ? {
                    backgroundImage: `url(${totBackground})`
                  }
                : pathname === "/" || pathname.includes("launch_controller")
                ? { backgroundColor: "#142943" }
                : pathname.includes("ochos-locos") &&
                  roomData?.game_state?.status === "Over"
                ? {
                    backgroundColor: "#1E3C60",
                    backgroundImage: `url(${
                      gameObj ? gameObj?.screens?.lobby?.background : ""
                    })`
                  }
                : pathname.includes("verboden") || roomData?.game_code === "VB"
                ? {
                    backgroundColor: "red !important"
                  }
                : pathname.includes("ochos-locos") &&
                  roomData?.game_state?.status === "ResultRound"
                ? {
                    backgroundColor: "#1E3C60",
                    backgroundImage: `url(${overBackgroundOCH})`
                  }
                : pathname.includes("ochos-locos")
                ? {
                    backgroundColor: "#1E3C60",
                    backgroundImage: `url(${
                      gameObj ? gameObj?.screens?.och?.background : ""
                    })`
                  }
                : pathname.includes("landing-library")
                ? {
                    backgroundColor: "#f8f8f8",
                    backgroundImage: "none"
                  }
                : roomData.game_code === "GAH" && !roomData?.edition
                ? {
                    backgroundColor: "#ABF6FF",
                    backgroundImage: `url(${
                      gameObj && gameObj.tabletop_bg_url
                        ? gameObj.tabletop_bg_url
                        : ""
                    })`
                  }
                : roomData.game_code === "TW"
                ? {
                    backgroundColor: "##FFFFFF",
                    backgroundImage: `url(${
                      gameObj && gameObj.tabletop_bg_url ? twBackground : ""
                    })`
                  }
                : roomData?.game_code === "OCH"
                ? {
                    backgroundImage: `url(${gameObj?.screens?.lobby?.background})`
                  }
                : roomData?.game_code === "CT"
                ? { backgroundImage: `url(${CTBG})` }
                : pathname.includes("charity-game") ||
                  (roomData?.game_code === "CHPT" && !roomData?.edition)
                ? {
                    backgroundImage: `url(${BoardRoom})`,
                    backgroundColor: "#722F82"
                  }
                : pathname.includes("slidekick") || roomData?.game_code === "SK"
                ? {
                    backgroundColor: "#f6f9ff"
                  }
                : roomData?.edition === "GAHW"
                ? {
                    backgroundColor: "#ABF6FF",
                    backgroundImage: `url(${
                      gameObj && gameObj.tabletop_bg_url_work
                        ? gameObj.tabletop_bg_url_work
                        : ""
                    })`
                  }
                : roomData?.edition === "GAHF"
                ? {
                    backgroundColor: "#ABF6FF",
                    backgroundImage: `url(${
                      gameObj && gameObj.tabletop_bg_url_family
                        ? gameObj.tabletop_bg_url_family
                        : ""
                    })`
                  }
                : roomData?.edition === "CHPTW"
                ? {
                    backgroundImage: `url(${BoardRoom})`,
                    backgroundColor: "#722F82"
                  }
                : { backgroundColor: "#1E3C60" }
            }
          >
            {!showDropdown() && (
              <div
                className={
                  this.state.dropdownOpen
                    ? "signin-dropdown logout-btn drop-active"
                    : "signin-dropdown logout-btn"
                }
                onClick={this.toggleHandel}
                onMouseEnter={this.toggleHandel}
                onMouseLeave={this.toggleHandel}
              >
                <Dropdown isOpen={this.state.dropdownOpen} toggle={() => {}}>
                  <DropdownToggle caret>
                    {this.state.cognitoUser ? (
                      <>
                        {user.picture === "profileImage" ? (
                          <div className="signin-cr">
                            <img src={avatar} alt="" />
                          </div>
                        ) : (
                          <div className="signin-cr signin-cr-img">
                            <img src={user.picture} alt="" />
                          </div>
                        )}
                        {/* <span className="signin-name">{user.username}</span> */}
                      </>
                    ) : (
                      <>
                        <div className="signin-cr">
                          <img src={avatar} alt="" />
                        </div>
                        <span className="signin-name">
                          {this.state.sign_in_text
                            ? this.state.sign_in_text
                            : "Sign In"}
                        </span>
                      </>
                    )}
                  </DropdownToggle>

                  <DropdownMenu>
                    {this.state.cognitoUser ? (
                      <DropdownItem header>
                        <div className="dropdown-head">
                          {user.picture === "profileImage" ? (
                            <span className="dropdown-head-cr">
                              <img src={avatar} alt="" />
                            </span>
                          ) : (
                            <span className="dropdown-head-cr head-profile-pic">
                              <img src={user.picture} alt="" />
                            </span>
                          )}

                          <div className="dropdown-head-txt">
                            <h3>Hello, {user.username}!</h3>

                            <Button
                              className="lg-out"
                              onClick={() => this.onLogOut()}
                            >
                              Log Out
                            </Button>
                          </div>
                        </div>
                      </DropdownItem>
                    ) : (
                      <DropdownItem header>
                        <div className="dropdown-head">
                          <span className="dropdown-head-cr">
                            <img src={avatar} alt="" />
                          </span>
                          <div className="dropdown-head-txt">
                            <h3>
                              {this.state.need_account_text
                                ? this.state.need_account_text
                                : "Need an account?"}
                            </h3>
                            <NavLink onClick={() => this.handleSignInForm()}>
                              {this.state.sign_in_sign_up_text
                                ? this.state.sign_in_sign_up_text
                                : "Sign In /Sign Up"}
                            </NavLink>
                          </div>
                        </div>
                      </DropdownItem>
                    )}
                    <div className="dropdown-body">
                      <a
                        href="https://www.gameapart.com/how-it-works/"
                        target="_blank"
                      >
                        {this.state.how_to_play_text
                          ? this.state.how_to_play_text
                          : "How to Play"}
                      </a>

                      <a
                        href="https://www.gameapart.com/join-game/"
                        target="_blank"
                      >
                        {this.state.join_a_game_text
                          ? this.state.join_a_game_text
                          : "Join a Game"}
                      </a>
                      <a href={this.state.play_laterURL} target="_blank">
                        {this.state.join_a_game_text
                          ? this.state.play_later_text
                          : "Play Later?"}
                      </a>

                      {this.state.cognitoUser && user.team && (
                        <a
                          onClick={() => {
                            this.props.setGameName("");
                            this.props.endGame(true);
                            this.props.emptyGameData({});
                            this.props.history.push("/my-team");
                          }}
                        >
                          {this.props.gameReducer?.gamesData?.onboarding
                            ?.my_team?.button_label || "My Team"}
                        </a>
                      )}
                      {this.state.cognitoUser && !user.team && (
                        <a
                          onClick={() =>
                            this.setState({
                              joinTeamModal: !this.state.joinTeamModal
                            })
                          }
                        >
                          {this.props.gameReducer.gamesData?.onboarding
                            ?.join_team?.button_label || "Join Team"}
                        </a>
                      )}
                    </div>
                  </DropdownMenu>
                </Dropdown>
              </div>
            )}
            {pathname.includes("done-with-2020") ? (
              <>
                <Header dw20 gameTitle={gameTitle} />
                <main className="flex-grow-1 d-flex justify-content-center flex-column">
                  {children}
                </main>
                <Footer history={history} params={params} dw20 />
              </>
            ) : pathname.includes("/outside_team_building") ? (
              <>
                <Header />
                <main className="d-flex justify-content-center flex-column">
                  <OPT history={history} />
                </main>
              </>
            ) : pathname.includes("charty-game") ? (
              <>
                <Header CHPT gameTitle={gameTitle} />
                <main className="flex-grow-1 d-flex">{children}</main>
                <Footer history={history} params={params} CHPT />
              </>
            ) : pathname.includes("tot") ? (
              <>
                <Header tot gameTitle={gameTitle} />
                <main className="flex-grow-1 d-flex justify-content-center flex-column">
                  {children}
                </main>
                <Footer history={history} params={params} tot />
              </>
            ) : pathname.includes("verboden") ? (
              <>
                <Header verboden gameTitle={gameTitle} />
                <main className="flex-grow-1 d-flex align-items-center">
                  {children}
                </main>
                {pathname !== "/verboden" && pathname !== "/verboden/" && (
                  <Footer history={history} params={params} verboden />
                )}
              </>
            ) : pathname.includes("ochos-locos") ? (
              <>
                <main className="flex-grow-1 d-flex">{children}</main>
                <Footer history={history} params={params} OCH />
              </>
            ) : pathname.includes("ct-game") ? (
              <>
                <Header CT gameTitle={gameTitle} />
                <main className="flex-grow-1 d-flex">{children}</main>
              </>
            ) : pathname.includes("smallBites") ? (
              <>
                <Header CT gameTitle={gameTitle} roomData={roomData} />
                <main className="flex-grow-1 d-flex">{children}</main>
              </>
            ) : pathname.includes("slidekick") ? (
              <>
                <Header slideKick gameTitle={gameTitle} />
                <main className="flex-grow-1 d-flex justify-content-center flex-column slidekick-bg">
                  {children}
                </main>
                <Footer history={history} params={params} slideKick />
              </>
            ) : pathname.includes("fluster") ? (
              <>
                <main className="flex-grow-1 d-flex justify-content-center flex-column">
                  {children}
                </main>
              </>
            ) : pathname.includes("bingo") ? (
              <>
                <Header BNG gameTitle={gameTitle} />
                <main className="d-flex justify-content-center flex-column">
                  {children}
                </main>
                <Footer history={history} params={params} BNG />
              </>
            ) : pathname === "/signup" ||
              pathname === "/pricing_page" ||
              pathname === "/delete_account" ||
              pathname === "/password_reset" ||
              pathname === "/invite_teammates" ||
              pathname === "/delete_account_success" ? (
              <>
                <HeyLimeLayout>{children}</HeyLimeLayout>
              </>
            ) : pathname.includes("/team-challenges") ||
              pathname.includes("/team-reports") ||
              pathname.includes("/activities") ||
              pathname.includes("/billing") ||
              pathname.includes("/no-team") ? (
              <>
                <main className="d-flex justify-content-center flex-column">
                  {children}
                </main>
              </>
            ) : pathname === "/" ||
              pathname === "/landing-library" ||
              pathname === "/lobby" ||
              pathname === "/launch_controller" ||
              pathname === "/wronghost" ||
              pathname === "/smallBites" ||
              pathname.includes("trial-login") ||
              pathname === "/my-team" ||
              pathname === "/my-team-new" ? (
              <>
                <Header
                  GAH={roomData?.game_code === "GAH" ? true : false}
                  gameTitle={gameTitle}
                />
                <main className="flex-grow-1">{children}</main>
              </>
            ) : roomData?.game_code === "GAH" ||
              roomData?.game_code === "GAHW" ||
              roomData?.game_code === "TW" ? (
              <>
                <Header
                  TW={roomData?.game_code === "TW" ? true : false}
                  GAH={
                    roomData?.game_code === "GAH" ||
                    roomData?.game_code === "GAHW"
                      ? true
                      : false
                  }
                  gameTitle={gameTitle}
                />
                <main
                  className={
                    roomData?.game_code === "GAH" ||
                    roomData?.game_code === "GAHW"
                      ? "main GAH-main"
                      : "main"
                  }
                >
                  {pathname === "/final-result" ? (
                    <div className="w-100">{children}</div>
                  ) : (
                    !this.isDirectGameLink() && (
                      <>
                        <div className="sidebarWrapper">
                          <Sidebar
                            {...this.props}
                            deletePlayer={this.deletePlayer}
                          />
                        </div>
                        <div className="bodyWrapper">
                          <div
                            className={cx("bodyContent acc-type-wrap", {
                              ["bg-transparent"]: pathname === "/win",
                              bodyContentTw: roomData?.game_code === "TW",
                              resultScreenTW:
                                roomData?.game_state?.status === "Result" &&
                                roomData?.game_code === "TW"
                            })}
                          >
                            {pathname === "/win" &&
                              (roomData?.game_code !== "GAH" ||
                                roomData?.game_code !== "GAHW") && (
                                <span className="layer-background" />
                              )}
                            {children}
                          </div>
                        </div>
                      </>
                    )
                  )}
                </main>
                {!this.isDirectGameLink() && (
                  <Footer
                    history={history}
                    params={params}
                    TW={roomData?.game_code === "TW" ? true : false}
                    GAH={roomData?.game_code === "GAH" ? true : false}
                  />
                )}
              </>
            ) : (
              <>
                <div className="321">
                  <Header />
                </div>
                <main className="flex-grow-1 1234">{children}</main>
              </>
            )}
            {this.state.joinTeamModal && (
              <JoinTeam
                modal={this.state.joinTeamModal}
                setModal={this.handleJoinTeamModal}
              />
            )}
            {roomData &&
              roomData.active_game &&
              this.show_join_team_modal()?.length > 0 && (
                <InGameJoinTeam
                  handle_reject_join_team={this.handle_reject_join_team}
                  users={this.show_join_team_modal()}
                  handle_accept_join_team={this.handle_accept_join_team}
                />
              )}
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  socketReducer: state.socketReducer,
  webUrlReducer: state.webUrlReducer
});

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    getAllParams: () => dispatch(gameParamAction.getAllParams()),
    getAudioParams: () => dispatch(gameParamAction.getAudioParams()),
    endGame: (data) => dispatch(gameAction.endGame(data)),
    setCurrentUser: (data) => dispatch(gameAction.setCurrentUser(data)),
    setSocket: (data) => dispatch(socketAction.setSocket(data)),
    setViewerWebUrl: (data) => dispatch(webUrlAction.setViewerWebUrl(data)),
    getAllGames: () => dispatch(gameAction.getAllGames()),
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    emptyGameData: (data) => dispatch(gameParamAction.emptyGameData(data))
  };
};

export default compose(
  withMsal,
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Layout);
